export default function useColorScheme() {
	return 'light';
}
